import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=678d1bf8&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678d1bf8')) {
      api.createRecord('678d1bf8', component.options)
    } else {
      api.reload('678d1bf8', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=678d1bf8&", function () {
      api.rerender('678d1bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25GY8LcGpjZxq/JS/comp/ErrorMessage.vue"
export default component.exports